var map = {
	"./cate-1.png": "c6d9",
	"./cate-2.png": "9770",
	"./cate-3.png": "5965",
	"./cate-4.png": "0c06",
	"./cate-5.png": "2c1f",
	"./cate-6.png": "3f18"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1030";